import { render, staticRenderFns } from "./ProjectSiteListingOngoingStatusSN.vue?vue&type=template&id=2ea5e4aa&"
import script from "./ProjectSiteListingOngoingStatusSN.vue?vue&type=script&lang=js&"
export * from "./ProjectSiteListingOngoingStatusSN.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSiteListingOngoingStatusSN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports